module.exports = __webpack_public_path__ + "img/seat-6.c43dc360.jpg";